import React, { FC } from 'react'

interface Props {
  color?: string
  flip?: boolean
  w?: number
  h?: number
}

const QuadrilateroVerde: FC<Props> = ({ color, flip, w, h }) => {
  const width = w || 372
  const height = h || 346
  const directionStyle = flip ? `scale(-1, 1) translate(-${width}, 0)` : '';

  return <svg width={width} height={height} xmlns="http://www.w3.org/2000/svg">
    <title>Quadrilatero verde</title>
    <g id="greenBackground" transform={directionStyle}>
      <path
        fill={color || '#1f855f'}
        id="svg_1"
        d={`
        m 0,10
        c 0,-5 5,-10 11,-10
        l ${width - 22},0
        c 6,0 11,4 11,10
        l -45,${height - 20}
        c 0,5 -5,10 -11,10
        l -${width - 68},0
        c -6,0 -11,-4 -11,-10
        `}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
  </svg>
}

export default QuadrilateroVerde
